import React from "react"
import Img from "gatsby-image"
import { ImgItem } from "./image-item"

const AboutInterval = ({ image }) => {
  return (
    <ImgItem>
      <Img fluid={image.childImageSharp.fluid} alt="Image" className="image" />

      <div className="textWrapper">
        <h1>Interval</h1>
        <p1>
          Here you can see the time remaining and the elapsed time of the
          interval. Once the remaining time reaches zero, it turns red and
          starts counting up. You can also receive interval notifications.
          These notify you "x" minutes before the Five and Beginners calls, or
          you can create custom notifications for the interval.

          The time a call happens, and the amount of time before the call that
          you receive a notification, are all configurable in Settings.
        </p1>
      </div>
    </ImgItem>
  )
}

export default AboutInterval